"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeddyDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ITeddyArt",
                name: "_art",
                type: "address",
            },
            {
                internalType: "contract ISVGRenderer",
                name: "_renderer",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "BadPaletteLength",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyPalette",
        type: "error",
    },
    {
        inputs: [],
        name: "IndexNotFound",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ITeddyArt",
                name: "art",
                type: "address",
            },
        ],
        name: "ArtUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISVGRenderer",
                name: "renderer",
                type: "address",
            },
        ],
        name: "RendererUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_background",
                type: "string",
            },
        ],
        name: "addBackground",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedCompressed",
                type: "bytes",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addBodies",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pointer",
                type: "address",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addBodiesFromPointer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedCompressed",
                type: "bytes",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addBodyAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pointer",
                type: "address",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addBodyAccessoriesFromPointer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedCompressed",
                type: "bytes",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addFaces",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pointer",
                type: "address",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addFacesFromPointer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedCompressed",
                type: "bytes",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addHeadAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pointer",
                type: "address",
            },
            {
                internalType: "uint80",
                name: "decompressedLength",
                type: "uint80",
            },
            {
                internalType: "uint16",
                name: "imageCount",
                type: "uint16",
            },
        ],
        name: "addHeadAccessoriesFromPointer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_backgrounds",
                type: "string[]",
            },
        ],
        name: "addManyBackgrounds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "art",
        outputs: [
            {
                internalType: "contract ITeddyArt",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "backgroundCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "backgrounds",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "bodies",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "bodyAccessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyAccessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "faceCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "faces",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "getPartsForSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "image",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "palette",
                        type: "bytes",
                    },
                ],
                internalType: "struct ISVGRenderer.Part[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "headAccessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headAccessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "index",
                type: "uint8",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renderer",
        outputs: [
            {
                internalType: "contract ISVGRenderer",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITeddyArt",
                name: "_art",
                type: "address",
            },
        ],
        name: "setArt",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "setArtDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IInflator",
                name: "inflator",
                type: "address",
            },
        ],
        name: "setArtInflator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "palette",
                type: "bytes",
            },
        ],
        name: "setPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "pointer",
                type: "address",
            },
        ],
        name: "setPalettePointer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISVGRenderer",
                name: "_renderer",
                type: "address",
            },
        ],
        name: "setRenderer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                ],
                internalType: "struct ITeddySeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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__$7233c33f2e1e35848c685b0eb24649959e$__916322cc1ad6916109b29173ffffffffffffffffffffffffffffffffffffffff909116908590600401612d88565b600060405180830381865af41580156109cf573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526109f79190810190612cbc565b9392505050565b6002546060907501000000000000000000000000000000000000000000900460ff1615610a3657610a2f8383610f2f565b9050610798565b6003610a418461237a565b604051602001610a52929190612e4d565b604051602081830303815290604052905092915050565b6001546040517f3fa5fe360000000000000000000000000000000000000000000000000000000081526004810183905260609173ffffffffffffffffffffffffffffffffffffffff1690633fa5fe3690602401610753565b6001546040517f44cee73c0000000000000000000000000000000000000000000000000000000081526004810183905260609173ffffffffffffffffffffffffffffffffffffffff16906344cee73c90602401610753565b600154604080517ffd30704b000000000000000000000000000000000000000000000000000000008152905160009273ffffffffffffffffffffffffffffffffffffffff169163fd30704b9160048083019260209291908290030181865afa158015610b89573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bad9190612ef2565b905090565b610bba612313565b6003610bc7828483612f56565b507f6741b2fc379fad678116fe3d4d4b9a1a184ab53ba36b86ad0fa66340b1ab41ad8282604051610bf992919061307d565b60405180910390a15050565b610c0d612313565b600280547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff83169081179091556040519081527f482cbbbcf912da3be80deb8503ae1e94c0b7d5d1d0ec0af3d9d6403e06e609ee906020015b60405180910390a150565b610c8f612313565b60025474010000000000000000000000000000000000000000900460ff1615610cfa5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f5d9b75b600000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff90911690635d9b75b690610d56908790879087908790600401613091565b600060405180830381600087803b158015610d7057600080fd5b505af1158015610d84573d6000803e3d6000fd5b5050505050505050565b600154604080517f64567f75000000000000000000000000000000000000000000000000000000008152905160009273ffffffffffffffffffffffffffffffffffffffff16916364567f7591600480830192869291908290030181865afa158015610dfd573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610e2591908101906130cc565b60200151905090565b610e36612313565b60025474010000000000000000000000000000000000000000900460ff1615610ea15760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f5e70664c00000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff90911690635e70664c90610ef9908590859060040161307d565b600060405180830381600087803b158015610f1357600080fd5b505af1158015610f27573d6000803e3d6000fd5b505050505050565b60606000610f3c8461237a565b9050600081604051602001610f5191906131f0565b6040516020818303038152906040529050600082604051602001610f759190613235565b6040516020818303038152906040529050610f91828287611226565b9695505050505050565b610fa3612313565b60025474010000000000000000000000000000000000000000900460ff161561100e5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f65d749d900000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff858116600483015269ffffffffffffffffffff8516602483015261ffff84166044830152909116906365d749d9906064015b600060405180830381600087803b15801561109857600080fd5b505af11580156110ac573d6000803e3d6000fd5b50505050505050565b600380546110c290612dfa565b80601f01602080910402602001604051908101604052809291908181526020018280546110ee90612dfa565b801561113b5780601f106111105761010080835404028352916020019161113b565b820191906000526020600020905b81548152906001019060200180831161111e57829003601f168201915b505050505081565b61114b612313565b60025474010000000000000000000000000000000000000000900460ff16156111b65760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f6d5d6ae400000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff90911690636d5d6ae490610d56908790879087908790600401613091565b61121a612313565b6112246000612438565b565b6040805160808101825284815260208101849052600154835183517f04bde4dd00000000000000000000000000000000000000000000000000000000815265ffffffffffff9091166004820152606093600093929083019173ffffffffffffffffffffffffffffffffffffffff909116906304bde4dd90602401600060405180830381865afa1580156112bd573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526112e59190810190612cbc565b81526020016112f385611828565b90526002546040517f92ba0e9000000000000000000000000000000000000000000000000000000000815291925073__$7233c33f2e1e35848c685b0eb24649959e$__916392ba0e90916113649173ffffffffffffffffffffffffffffffffffffffff9091169085906004016132a1565b600060405180830381865af4158015611381573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526113a99190810190612cbc565b95945050505050565b6113ba612313565b60025474010000000000000000000000000000000000000000900460ff16156114255760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f8bd54c0600000000000000000000000000000000000000000000000000000000815260ff8416600482015273ffffffffffffffffffffffffffffffffffffffff838116602483015290911690638bd54c0690604401610ef9565b61148e612313565b60025474010000000000000000000000000000000000000000900460ff16156114f95760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f8d43848100000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff858116600483015269ffffffffffffffffffff8516602483015261ffff8416604483015290911690638d4384819060640161107e565b611575612313565b60025474010000000000000000000000000000000000000000900460ff16156115e05760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517f91b7916a00000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff909116906391b7916a90610ef99085908590600401613350565b611640612313565b60025474010000000000000000000000000000000000000000900460ff16156116ab5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517faa5bf7d800000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff9091169063aa5bf7d890610d56908790879087908790600401613091565b6001546040517fae6f44670000000000000000000000000000000000000000000000000000000081526004810183905260609173ffffffffffffffffffffffffffffffffffffffff169063ae6f446790602401610753565b600154604080517f8d1e22df000000000000000000000000000000000000000000000000000000008152905160009273ffffffffffffffffffffffffffffffffffffffff1691638d1e22df91600480830192869291908290030181865afa158015610dfd573d6000803e3d6000fd5b6001546040517fbc2d45fe00000000000000000000000000000000000000000000000000000000815260ff8316600482015260609173ffffffffffffffffffffffffffffffffffffffff169063bc2d45fe90602401610753565b60015460208201516040517f44cee73c00000000000000000000000000000000000000000000000000000000815265ffffffffffff909116600482015260609160009173ffffffffffffffffffffffffffffffffffffffff909116906344cee73c90602401600060405180830381865afa1580156118aa573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526118d29190810190612cbc565b60015460608501516040517f3fa5fe3600000000000000000000000000000000000000000000000000000000815265ffffffffffff909116600482015291925060009173ffffffffffffffffffffffffffffffffffffffff90911690633fa5fe3690602401600060405180830381865afa158015611954573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261197c9190810190612cbc565b60015460408681015190517fae6f446700000000000000000000000000000000000000000000000000000000815265ffffffffffff909116600482015291925060009173ffffffffffffffffffffffffffffffffffffffff9091169063ae6f446790602401600060405180830381865afa1580156119fe573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611a269190810190612cbc565b60015460808701516040517fda7de20700000000000000000000000000000000000000000000000000000000815265ffffffffffff909116600482015291925060009173ffffffffffffffffffffffffffffffffffffffff9091169063da7de20790602401600060405180830381865afa158015611aa8573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611ad09190810190612cbc565b60408051600480825260a0820190925291925060009190816020015b6040805180820190915260608082526020820152815260200190600190039081611aec5790505090506040518060400160405280868152602001611b2f876124ad565b81525081600081518110611b4557611b4561341a565b60200260200101819052506040518060400160405280858152602001611b6a866124ad565b81525081600181518110611b8057611b8061341a565b60200260200101819052506040518060400160405280848152602001611ba5856124ad565b81525081600281518110611bbb57611bbb61341a565b60200260200101819052506040518060400160405280838152602001611be0846124ad565b81525081600381518110611bf657611bf661341a565b60209081029190910101529695505050505050565b611c13612313565b60025474010000000000000000000000000000000000000000900460ff1615611c7e5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517fcb087de600000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff858116600483015269ffffffffffffffffffff8516602483015261ffff841660448301529091169063cb087de69060640161107e565b611cfa612313565b60025474010000000000000000000000000000000000000000900460ff1615611d655760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517fcd2b825000000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff858116600483015269ffffffffffffffffffff8516602483015261ffff841660448301529091169063cd2b82509060640161107e565b600154604080517f8de0d70e000000000000000000000000000000000000000000000000000000008152905160009273ffffffffffffffffffffffffffffffffffffffff1691638de0d70e91600480830192869291908290030181865afa158015610dfd573d6000803e3d6000fd5b6001546040517fda7de2070000000000000000000000000000000000000000000000000000000081526004810183905260609173ffffffffffffffffffffffffffffffffffffffff169063da7de20790602401610753565b611ea8612313565b600280547fffffffffffffffffffff00ffffffffffffffffffffffffffffffffffffffffff811675010000000000000000000000000000000000000000009182900460ff1615918202179091556040518181527f360c3d72ee193226275b842f85231c259c934e85459fed80fa68e502ffa9dbde90602001610c7c565b611f2d612313565b60025474010000000000000000000000000000000000000000900460ff1615611f985760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b600180547fffffffffffffffffffffffff00000000000000000000000000000000000000001673ffffffffffffffffffffffffffffffffffffffff83169081179091556040519081527f89382d75256b43b6826ad8d6cbd8e517eaf5e10f1ef4c8f123c9a25ac4529b5590602001610c7c565b612013612313565b60025474010000000000000000000000000000000000000000900460ff161561207e5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517fe79c9ea600000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff9091169063e79c9ea69061107e90869086908690600401613449565b600154604080517f222a36d0000000000000000000000000000000000000000000000000000000008152905160009273ffffffffffffffffffffffffffffffffffffffff169163222a36d091600480830192869291908290030181865afa158015610dfd573d6000803e3d6000fd5b61214f612313565b60025474010000000000000000000000000000000000000000900460ff16156121ba5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b656400000000000000000000000000000000604482015260640161080d565b6001546040517ff0f29f4f00000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff9091169063f0f29f4f90610d56908790879087908790600401613091565b61221e612313565b73ffffffffffffffffffffffffffffffffffffffff81166122a75760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f6464726573730000000000000000000000000000000000000000000000000000606482015260840161080d565b6122b081612438565b50565b6122bb612313565b6001546040517f72aa4a9600000000000000000000000000000000000000000000000000000000815273ffffffffffffffffffffffffffffffffffffffff8381166004830152909116906372aa4a96906024016106ca565b60005473ffffffffffffffffffffffffffffffffffffffff1633146112245760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161080d565b6060600061238783612527565b600101905060008167ffffffffffffffff8111156123a7576123a76126c4565b6040519080825280601f01601f1916602001820160405280156123d1576020820181803683370190505b5090508181016020015b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff017f3031323334353637383961626364656600000000000000000000000000000000600a86061a8153600a85049450846123db57509392505050565b6000805473ffffffffffffffffffffffffffffffffffffffff8381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b600154815160609173ffffffffffffffffffffffffffffffffffffffff169063bc2d45fe9084906000906124e3576124e361341a565b01602001516040517fffffffff0000000000000000000000000000000000000000000000000000000060e084901b16815260f89190911c6004820152602401610753565b6000807a184f03e93ff9f4daa797ed6e38ed64bf6a1f0100000000000000008310612570577a184f03e93ff9f4daa797ed6e38ed64bf6a1f010000000000000000830492506040015b6d04ee2d6d415b85acef8100000000831061259c576d04ee2d6d415b85acef8100000000830492506020015b662386f26fc1000083106125ba57662386f26fc10000830492506010015b6305f5e10083106125d2576305f5e100830492506008015b61271083106125e657612710830492506004015b606483106125f8576064830492506002015b600a83106107985760010192915050565b73ffffffffffffffffffffffffffffffffffffffff811681146122b057600080fd5b60006020828403121561263d57600080fd5b81356109f781612609565b60006020828403121561265a57600080fd5b5035919050565b60005b8381101561267c578181015183820152602001612664565b50506000910152565b6000815180845261269d816020860160208601612661565b601f01601f19169290920160200192915050565b6020815260006109f76020830184612685565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6040805190810167ffffffffffffffff81118282101715612716576127166126c4565b60405290565b6040516060810167ffffffffffffffff81118282101715612716576127166126c4565b604051601f8201601f1916810167ffffffffffffffff81118282101715612768576127686126c4565b604052919050565b803565ffffffffffff8116811461278657600080fd5b919050565b600060a0828403121561279d57600080fd5b60405160a0810181811067ffffffffffffffff821117156127c0576127c06126c4565b6040529050806127cf83612770565b81526127dd60208401612770565b60208201526127ee60408401612770565b60408201526127ff60608401612770565b606082015261281060808401612770565b60808201525092915050565b600060a0828403121561282e57600080fd5b6109f7838361278b565b60008060c0838503121561284b57600080fd5b8235915061285c846020850161278b565b90509250929050565b60008083601f84011261287757600080fd5b50813567ffffffffffffffff81111561288f57600080fd5b6020830191508360208285010111156128a757600080fd5b9250929050565b600080602083850312156128c157600080fd5b823567ffffffffffffffff8111156128d857600080fd5b6128e485828601612865565b90969095509350505050565b69ffffffffffffffffffff811681146122b057600080fd5b61ffff811681146122b057600080fd5b6000806000806060858703121561292e57600080fd5b843567ffffffffffffffff81111561294557600080fd5b61295187828801612865565b9095509350506020850135612965816128f0565b9150604085013561297581612908565b939692955090935050565b60008060006060848603121561299557600080fd5b83356129a081612609565b925060208401356129b0816128f0565b915060408401356129c081612908565b809150509250925092565b600067ffffffffffffffff8211156129e5576129e56126c4565b50601f01601f191660200190565b600082601f830112612a0457600080fd5b8135612a17612a12826129cb565b61273f565b818152846020838601011115612a2c57600080fd5b816020850160208301376000918101602001919091529392505050565b600080600060e08486031215612a5e57600080fd5b833567ffffffffffffffff80821115612a7657600080fd5b612a82878388016129f3565b94506020860135915080821115612a9857600080fd5b50612aa5868287016129f3565b925050612ab5856040860161278b565b90509250925092565b803560ff8116811461278657600080fd5b60008060408385031215612ae257600080fd5b612aeb83612abe565b91506020830135612afb81612609565b809150509250929050565b60008060208385031215612b1957600080fd5b823567ffffffffffffffff80821115612b3157600080fd5b818501915085601f830112612b4557600080fd5b813581811115612b5457600080fd5b8660208260051b8501011115612b6957600080fd5b60209290920196919550909350505050565b600060208284031215612b8d57600080fd5b6109f782612abe565b60006020808301818452808551808352604092508286019150828160051b87010184880160005b83811015612c2b577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc089840301855281518051878552612bff88860182612685565b91890151858303868b0152919050612c178183612685565b968901969450505090860190600101612bbd565b509098975050505050505050565b600080600060408486031215612c4e57600080fd5b612c5784612abe565b9250602084013567ffffffffffffffff811115612c7357600080fd5b612c7f86828701612865565b9497909650939450505050565b6000612c9a612a12846129cb565b9050828152838383011115612cae57600080fd5b6109f7836020830184612661565b600060208284031215612cce57600080fd5b815167ffffffffffffffff811115612ce557600080fd5b8201601f81018413612cf657600080fd5b612d0584825160208401612c8c565b949350505050565b600081518084526020808501808196508360051b8101915082860160005b85811015612d7b578284038952815160408151818752612d4d82880182612685565b91505086820151915085810387870152612d678183612685565b9a87019a9550505090840190600101612d2b565b5091979650505050505050565b73ffffffffffffffffffffffffffffffffffffffff831681526040602082015260008251604080840152612dbf6080840182612d0d565b905060208401517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc0848303016060850152610f918282612685565b600181811c90821680612e0e57607f821691505b602082108103612e47577f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b50919050565b6000808454612e5b81612dfa565b60018281168015612e735760018114612ea657612ed5565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0084168752821515830287019450612ed5565b8860005260208060002060005b85811015612ecc5781548a820152908401908201612eb3565b50505082870194505b505050508351612ee9818360208801612661565b01949350505050565b600060208284031215612f0457600080fd5b5051919050565b601f821115612f5157600081815260208120601f850160051c81016020861015612f325750805b601f850160051c820191505b81811015610f2757828155600101612f3e565b505050565b67ffffffffffffffff831115612f6e57612f6e6126c4565b612f8283612f7c8354612dfa565b83612f0b565b6000601f841160018114612fd45760008515612f9e5750838201355b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff600387901b1c1916600186901b1783556106f8565b600083815260209020601f19861690835b828110156130055786850135825560209485019460019092019101612fe5565b5086821015613040577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff60f88860031b161c19848701351681555b505060018560011b0183555050505050565b818352818160208501375060006020828401015260006020601f19601f840116840101905092915050565b602081526000612d05602083018486613052565b6060815260006130a5606083018688613052565b905069ffffffffffffffffffff8416602083015261ffff8316604083015295945050505050565b600060208083850312156130df57600080fd5b825167ffffffffffffffff808211156130f757600080fd5b8185019150604080838803121561310d57600080fd5b6131156126f3565b83518381111561312457600080fd5b8401601f8101891361313557600080fd5b805184811115613147576131476126c4565b613155878260051b0161273f565b8181528781019550606091820283018801918b83111561317457600080fd5b928801925b828410156131d75780848d0312156131915760008081fd5b61319961271c565b84516131a481612908565b8152848a01516131b3816128f0565b818b0152848701516131c481612609565b8188015287529588019592830192613179565b5083525050928401519383019390935250949350505050565b7f5465646479200000000000000000000000000000000000000000000000000000815260008251613228816006850160208701612661565b9190910160060192915050565b7f546564647920000000000000000000000000000000000000000000000000000081526000825161326d816006850160208701612661565b7f2069732061206d656d626572206f66207468652054656464792044414f0000006006939091019283015250602301919050565b73ffffffffffffffffffffffffffffffffffffffff831681526040602082015260008251608060408401526132d960c0840182612685565b905060208401517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc0808584030160608601526133158383612685565b925060408601519150808584030160808601526133328383612685565b925060608601519150808584030160a086015250610f918282612d0d565b60208082528181018390526000906040600585901b8401810190840186845b87811015612d7b577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc087850301835281357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe18a36030181126133d057600080fd5b8901858101903567ffffffffffffffff8111156133ec57600080fd5b8036038213156133fb57600080fd5b613406868284613052565b95505050918401919084019060010161336f565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b60ff841681526040602082015260006113a960408301848661305256fea264697066735822122072aa057cca797cc1247d410710973db6a397cdc4500c508d3b31439bba418d2664736f6c63430008110033";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class TeddyDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, TeddyDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$7233c33f2e1e35848c685b0eb24649959e\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptorV2.sol:NFTDescriptorV2"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(_art, _renderer, overrides) {
        return super.deploy(_art, _renderer, overrides || {});
    }
    getDeployTransaction(_art, _renderer, overrides) {
        return super.getDeployTransaction(_art, _renderer, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TeddyDescriptor__factory = TeddyDescriptor__factory;
TeddyDescriptor__factory.bytecode = _bytecode;
TeddyDescriptor__factory.abi = _abi;
